import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdnowWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100px",
	height: "38px",
	viewBox: "0 0 1024 225",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
			d: "M885,0 L885,225 L0,225 L0,218.463 L27.586,218.463 C86.50783,218.463 134.55447,170.303826 135.509511,110.736524 L135.524,108.928 C135.524,49.46662 88.0665779,0.9784396 29.3681439,0.01462213 L27.586,0 L885,0 Z",
			id: "logo-mask-path"
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "logo",
			stroke: "none",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "now-container",
					transform: "translate(139.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("mask", {
						id: "logo-now-mask",
						fill: "white",
						children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#logo-mask-path" })
					}), /* @__PURE__ */ _jsx("g", {
						id: "now",
						mask: "url(#logo-now-mask)",
						fill: "#FFFFFF",
						transform: "translate(0,0)",
						children: /* @__PURE__ */ _jsx("g", {
							className: "now-maksed",
							transform: "translate(0,0)",
							children: /* @__PURE__ */ _jsxs("g", {
								transform: "translate(166.749000, 31.488000)",
								children: [
									/* @__PURE__ */ _jsx("path", {
										d: "M662.462,6.984 C661.579,5.779 660.174,5.066 658.679,5.066 L619.393,5.066 C617.328,5.066 615.505,6.419 614.904,8.393 L587.816,97.639 L546.883,8.494 C546.663,7.743 546.251,7.048 545.696,6.479 C544.814,5.576 543.566,5.066 542.304,5.066 L525.055,5.066 C523.792,5.066 522.585,5.655 521.702,6.557 C521.232,7.04 520.876,7.632 520.65,8.274 L479.614,97.637 L452.528,8.393 C451.928,6.419 450.106,5.066 448.041,5.066 L408.752,5.066 C407.258,5.066 405.853,5.779 404.97,6.984 C404.087,8.189 403.83,9.745 404.281,11.17 L458.801,183.654 C459.418,185.603 461.226,186.929 463.272,186.929 L488.647,186.929 C490.483,186.929 492.15,185.857 492.911,184.189 L533.717,94.885 L574.523,184.189 C575.284,185.857 576.951,186.929 578.786,186.929 L604.159,186.929 C606.205,186.929 608.014,185.603 608.631,183.654 L663.15,11.17 C663.601,9.745 663.345,8.189 662.462,6.984",
										id: "w"
									}),
									/* @__PURE__ */ _jsx("path", {
										d: "M297.293,0 C350.634,0 394.029,43.401 394.029,96.747 C394.029,150.104 350.634,193.512 297.293,193.512 C243.932,193.512 200.52,150.104 200.52,96.747 C200.52,43.401 243.932,0 297.293,0 Z M297.293,47.334 C270.031,47.334 247.853,69.5 247.853,96.747 C247.853,124.004 270.031,146.178 297.293,146.178 C324.529,146.178 346.688,124.004 346.688,96.747 C346.688,69.5 324.529,47.334 297.293,47.334 Z",
										id: "o"
									}),
									/* @__PURE__ */ _jsx("path", {
										d: "M170.223,87.392 L170.223,182.286 C170.223,184.876 168.123,186.975 165.533,186.975 L127.044,186.975 C124.453,186.975 122.354,184.876 122.354,182.286 L122.354,85.669 C122.354,61.156 111.305,47.656 91.244,47.656 C66.666,47.656 50.636,64.917 48.061,69.822 L48.061,182.286 C48.061,184.876 45.962,186.975 43.372,186.975 L4.689,186.975 C2.099,186.975 -2.84217094e-14,184.876 -2.84217094e-14,182.286 L-2.84217094e-14,9.755 C-2.84217094e-14,7.166 2.099,5.066 4.689,5.066 L30.936,5.066 C33.112,5.066 35.003,6.563 35.501,8.68 L38.382,20.922 C47.991,13.347 68.166,0.755 95.994,0.755 C145.249,0.755 170.223,29.903 170.223,87.392",
										id: "n"
									})
								]
							})
						})
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M993.6661,164.004184 C1010.2971,164.0212 1023.9421,177.5762 1023.99927,194.1372 C1024.0561,210.7392 1009.8941,225.0982 993.5601,224.999709 C977.1891,224.9002 962.9671,210.4242 963.1301,194.0262 C963.2951,177.5532 977.0921,163.9872 993.6661,164.004184",
					id: "period",
					className: "period",
					fill: "#FF6B40"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.586,0 C226.103,0 274.524,48.866 274.524,108.928 C274.524,169.326 226.103,218.463 166.586,218.463 L91.569,218.463 C88.979,218.463 86.88,216.364 86.88,213.774 L86.88,4.69 C86.88,2.099 88.979,0 91.569,0 L166.586,0 Z M165.637,45.519 L134.203,45.519 L134.203,172.64 L163.055,172.64 C182.322,172.64 199.228,164.784 210.659,150.516 C223.181,134.888 227.486,113.051 222.472,90.608 C216.636,64.481 192.734,45.519 165.637,45.519 Z",
					id: "D",
					fill: "#FFFFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.602,0 L4.689,0 C2.099,0 0,2.099 0,4.69 C0,4.69 0.106,213.695 0.106,213.788 C0.113,216.37 2.211,218.463 4.795,218.463 L42.595,218.463 C45.185,218.463 47.291,216.356 47.291,213.766 L47.291,4.69 C47.291,2.099 45.192,0 42.602,0",
					id: "I",
					fill: "#FFFFFF"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgIdnowWhite);
export { ForwardRef as ReactComponent };
